
import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data(){
return {
phoneNoIcon:false,
showtel:false,
showToast:false,
toastShow:false,
toastTxt:'',
title:'',
num:'',
bigtitle:'',
total:'',
integra:'',
mobile:''

}
},
components: {
XDialog,XInput,XButton,XHeader, Cell, Group,Toast,Icon
},
directives: {
TransferDom
},
computed:{
},
methods:{
IconClick(text){
this.toastShow = true;
this.toastTxt = text;
},
telchange(){
let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.mobile = this.mobile.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.mobile) && this.mobile){
this.phoneNoIcon = false;
}else{
this.phoneNoIcon = true;
if(!this.mobile){
return false;
}
this.IconClick('电话号码格式不正确，请核实！');

}
})

}, //电话验证
telsure(){
if(this.mobile && !this.phoneNoIcon){  //通过手机验证
this.showtel =false;
this.showToast =true;
}else{
this.IconClick('输入的手机号码不正确！')
}
}, //确认号码
submit(){
console.log(this.mobile)
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.sureParma = new URLSearchParams();
this.sureParma.append('personInfoId',this.paramsData.personInfoId);
this.sureParma.append('orderId',this.paramsData.orderId);
this.sureParma.append('isUseScore',1);
this.sureParma.append('xm',this.paramsData.xm);
this.sureParma.append('sfzh',this.paramsData.sfzh);
this.sureParma.append('openid',this.paramsData.openid);
this.sureParma.append('mobile',this.mobile);
this.sureParma.append('gzhArea',this.paramsData.hosCode);
fetch('post',urlConfig.jifenSurePay,this.sureParma).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
if(this.paramsData.months){  //如果是胚胎
this.embryoParma = new URLSearchParams();
this.embryoParma.append('chargeId',this.paramsData.chargeId);
this.embryoParma.append('sysid',this.paramsData.sysid);
this.embryoParma.append('dqrq',this.paramsData.dqrq);
this.embryoParma.append('patientId',this.paramsData.patientId);
this.embryoParma.append('months',this.paramsData.months);
this.embryoParma.append('gzhArea',this.paramsData.hosCode);
fetch('post',urlConfig.jifenOrderEmbryo,this.embryoParma).then(response => {
this.$router.push({ path: 'integralMallOrderResult',query:{openid:this.paramsData.openid,sign:this.$route.query.sign,hosCode:this.paramsData.hosCode}});
}).catch(error => {

})
}else {
this.$router.push({ path: 'integralMallOrderResult',query:{openid:this.paramsData.openid,sign:this.$route.query.sign,hosCode:this.paramsData.hosCode}});
}


}).catch(error => {

})
},
sureClick(){
this.mobile = this.paramsData.mobile;
this.telchange();
if(this.bigtitle.indexOf('大众点评') !=-1){  //是大众点评
this.showtel = true;

}else{
this.submit();
}

}  //确认支付
},
mounted(){
this.paramsData = this.$route.query;
this.title = this.paramsData.title;
this.bigtitle = this.paramsData.bigtitle;
this.num = this.paramsData.num;
this.integra = this.paramsData.integra;
this.total = this.paramsData.total;


}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallOrder.vue